// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/documents.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { IssueAttachmentMetadata } from "./attachments";
import { EntityMeta } from "./common";

export const protobufPackage = "api.devplan.types.documents";

export enum DocumentType {
  UNKNOWN_DOCUMENT_TYPE = 0,
  PRD = 1,
  PROJECT_PLAN = 2,
  FEATURE = 3,
  TASK = 4,
  CUSTOM_DOCUMENT = 5,
  CODING_ASSISTANT = 6,
  IDEA_DISCOVERY = 7,
}

export function documentTypeFromJSON(object: any): DocumentType {
  switch (object) {
    case 0:
    case "UNKNOWN_DOCUMENT_TYPE":
      return DocumentType.UNKNOWN_DOCUMENT_TYPE;
    case 1:
    case "PRD":
      return DocumentType.PRD;
    case 2:
    case "PROJECT_PLAN":
      return DocumentType.PROJECT_PLAN;
    case 3:
    case "FEATURE":
      return DocumentType.FEATURE;
    case 4:
    case "TASK":
      return DocumentType.TASK;
    case 5:
    case "CUSTOM_DOCUMENT":
      return DocumentType.CUSTOM_DOCUMENT;
    case 6:
    case "CODING_ASSISTANT":
      return DocumentType.CODING_ASSISTANT;
    case 7:
    case "IDEA_DISCOVERY":
      return DocumentType.IDEA_DISCOVERY;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum DocumentType");
  }
}

export function documentTypeToJSON(object: DocumentType): string {
  switch (object) {
    case DocumentType.UNKNOWN_DOCUMENT_TYPE:
      return "UNKNOWN_DOCUMENT_TYPE";
    case DocumentType.PRD:
      return "PRD";
    case DocumentType.PROJECT_PLAN:
      return "PROJECT_PLAN";
    case DocumentType.FEATURE:
      return "FEATURE";
    case DocumentType.TASK:
      return "TASK";
    case DocumentType.CUSTOM_DOCUMENT:
      return "CUSTOM_DOCUMENT";
    case DocumentType.CODING_ASSISTANT:
      return "CODING_ASSISTANT";
    case DocumentType.IDEA_DISCOVERY:
      return "IDEA_DISCOVERY";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum DocumentType");
  }
}

export enum ProjectEntityType {
  UNKNOWN_DOC_TYPE = 0,
  REQUIREMENTS = 1,
  PLAN = 2,
  PLAN_ITEM = 3,
  PLAN_SUB_ITEM = 4,
}

export function projectEntityTypeFromJSON(object: any): ProjectEntityType {
  switch (object) {
    case 0:
    case "UNKNOWN_DOC_TYPE":
      return ProjectEntityType.UNKNOWN_DOC_TYPE;
    case 1:
    case "REQUIREMENTS":
      return ProjectEntityType.REQUIREMENTS;
    case 2:
    case "PLAN":
      return ProjectEntityType.PLAN;
    case 3:
    case "PLAN_ITEM":
      return ProjectEntityType.PLAN_ITEM;
    case 4:
    case "PLAN_SUB_ITEM":
      return ProjectEntityType.PLAN_SUB_ITEM;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ProjectEntityType");
  }
}

export function projectEntityTypeToJSON(object: ProjectEntityType): string {
  switch (object) {
    case ProjectEntityType.UNKNOWN_DOC_TYPE:
      return "UNKNOWN_DOC_TYPE";
    case ProjectEntityType.REQUIREMENTS:
      return "REQUIREMENTS";
    case ProjectEntityType.PLAN:
      return "PLAN";
    case ProjectEntityType.PLAN_ITEM:
      return "PLAN_ITEM";
    case ProjectEntityType.PLAN_SUB_ITEM:
      return "PLAN_SUB_ITEM";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ProjectEntityType");
  }
}

export enum ProjectStatus {
  UNKNOWN = 0,
  DRAFT = 1,
  IN_REVIEW = 2,
  READY_FOR_DEV = 3,
  DONE = 4,
  DELIVERY = 5,
}

export function projectStatusFromJSON(object: any): ProjectStatus {
  switch (object) {
    case 0:
    case "UNKNOWN":
      return ProjectStatus.UNKNOWN;
    case 1:
    case "DRAFT":
      return ProjectStatus.DRAFT;
    case 2:
    case "IN_REVIEW":
      return ProjectStatus.IN_REVIEW;
    case 3:
    case "READY_FOR_DEV":
      return ProjectStatus.READY_FOR_DEV;
    case 4:
    case "DONE":
      return ProjectStatus.DONE;
    case 5:
    case "DELIVERY":
      return ProjectStatus.DELIVERY;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ProjectStatus");
  }
}

export function projectStatusToJSON(object: ProjectStatus): string {
  switch (object) {
    case ProjectStatus.UNKNOWN:
      return "UNKNOWN";
    case ProjectStatus.DRAFT:
      return "DRAFT";
    case ProjectStatus.IN_REVIEW:
      return "IN_REVIEW";
    case ProjectStatus.READY_FOR_DEV:
      return "READY_FOR_DEV";
    case ProjectStatus.DONE:
      return "DONE";
    case ProjectStatus.DELIVERY:
      return "DELIVERY";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum ProjectStatus");
  }
}

export interface DocumentEntity {
  id: string;
  title: string;
  type: DocumentType;
  companyId: number;
  projectId: string;
  parentId?: string | undefined;
  description?: string | undefined;
  content?: string | undefined;
  details?: string | undefined;
  templateId: string;
  initialInput?: string | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  createdBy?:
    | string
    | undefined;
  /** True if a document is part of a draft. */
  isDraftPart: boolean;
  numericId?:
    | number
    | undefined;
  /** Stable slug for directory naming (preserves folder names across renames) */
  slug?: string | undefined;
}

export interface DocumentInitialInput {
  structuredInput: DocumentSectionValue[];
  /** Deprecated: Use image_urls instead */
  imageUrl?: string | undefined;
  imageUrls: string[];
  attachmentIds: string[];
  issueAttachments: IssueAttachmentMetadata[];
}

export interface DocumentSectionValue {
  name: string;
  value: string;
}

export interface ProjectEntity {
  id: string;
  templateId: string;
  companyId: number;
  title: string;
  details: ProjectDetails | undefined;
  createdAt: Date | undefined;
  updatedAt: Date | undefined;
  createdBy?: string | undefined;
  numericId?:
    | number
    | undefined;
  /** Stable slug for directory naming (preserves folder names across renames) */
  slug?: string | undefined;
  kind?: string | undefined;
  isArchived: boolean;
}

export interface StageTimeline {
  start?: Date | undefined;
  finish?: Date | undefined;
}

export interface ProjectDetails {
  status: ProjectStatus;
  /** Id of the user who owns this project. */
  owner?:
    | string
    | undefined;
  /** Description field used for idea projects. */
  description?:
    | string
    | undefined;
  /** Tag IDs for projects. */
  tagIds: string[];
  /** Phase timeline dates (Definition, Development, Delivery). */
  definition?: StageTimeline | undefined;
  development?: StageTimeline | undefined;
  delivery?:
    | StageTimeline
    | undefined;
  /** Workspace-scoped release assigned to this project. */
  releaseId?: string | undefined;
}

export interface CustomDocumentDetails {
  /** Extra prompt parameters that will be injected into the system and user prompts. */
  extraPromptParams: { [key: string]: string };
}

export interface CustomDocumentDetails_ExtraPromptParamsEntry {
  key: string;
  value: string;
}

export interface PrdDetails {
  /** If true, indicates the PRD content is user-provided and should bypass standard refinement/chat flows */
  userProvidedSpec: boolean;
  /** Summary of the product brief, optimized for quick executive consumption */
  summary?: string | undefined;
}

export interface IdeaDiscoveryDetails {
  /** RICE score parameters */
  riceScore?:
    | RiceScore
    | undefined;
  /** Summary of the discovery brief */
  summary?: string | undefined;
}

export interface ReachScore {
  /** Reach: percentage of users impacted (0-100) */
  score: number;
  /** Explanation for the reach value */
  reasoning?: string | undefined;
}

export interface ImpactScore {
  /** Impact score (1 = XS Extra Small, 2 = Small, 3 = Medium, 4 = Large, 5 = XL Extra Large) */
  score: number;
  /** Explanation for the impact value */
  reasoning?:
    | string
    | undefined;
  /** Human-readable impact label */
  label?: string | undefined;
}

export interface ConfidenceScore {
  /** Confidence percentage (0-100) */
  score: number;
  /** Explanation for the confidence value */
  reasoning?: string | undefined;
}

export interface EffortScore {
  /** Effort score (1 = Very Small, 2 = Small, 3 = Medium, 4 = Large, 5 = Very Large) */
  score: number;
  /** Explanation for the effort value */
  reasoning?: string | undefined;
}

export interface RiceScore {
  reach: ReachScore | undefined;
  impact: ImpactScore | undefined;
  confidence: ConfidenceScore | undefined;
  effort: EffortScore | undefined;
  executiveSummary?: string | undefined;
}

export interface ProjectWithDocs {
  project: ProjectEntity | undefined;
  docs: DocumentEntity[];
}

export interface DocumentWithProject {
  doc: DocumentEntity | undefined;
  project: ProjectEntity | undefined;
}

export interface SteppedFeaturePromptContent {
  steps: SteppedFeaturePromptContent_Step[];
  requirementsSummary: string;
}

export interface SteppedFeaturePromptContent_Step {
  name: string;
  instructions: string;
}

/** Release represents a company-scoped project release/fix version value. */
export interface Release {
  id: string;
  meta: EntityMeta | undefined;
  name: string;
  companyId: number;
  archived: boolean;
  /** Optional planned/target date for the release. */
  targetDate?:
    | Date
    | undefined;
  /**
   * Explicit ordering of project ids in the by-release roadmap view. Projects
   * assigned to the release that don't appear here are appended at the end in
   * their default (section-view) order. Edited via roadmap drag-reorder; not
   * used by section/status views.
   */
  projectOrder: string[];
}

function createBaseDocumentEntity(): DocumentEntity {
  return {
    id: "",
    title: "",
    type: 0,
    companyId: 0,
    projectId: "",
    parentId: undefined,
    description: undefined,
    content: undefined,
    details: undefined,
    templateId: "",
    initialInput: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: undefined,
    isDraftPart: false,
    numericId: undefined,
    slug: undefined,
  };
}

export const DocumentEntity: MessageFns<DocumentEntity> = {
  encode(message: DocumentEntity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.title !== "") {
      writer.uint32(18).string(message.title);
    }
    if (message.type !== 0) {
      writer.uint32(24).int32(message.type);
    }
    if (message.companyId !== 0) {
      writer.uint32(32).int32(message.companyId);
    }
    if (message.projectId !== "") {
      writer.uint32(42).string(message.projectId);
    }
    if (message.parentId !== undefined) {
      writer.uint32(50).string(message.parentId);
    }
    if (message.description !== undefined) {
      writer.uint32(58).string(message.description);
    }
    if (message.content !== undefined) {
      writer.uint32(66).string(message.content);
    }
    if (message.details !== undefined) {
      writer.uint32(74).string(message.details);
    }
    if (message.templateId !== "") {
      writer.uint32(82).string(message.templateId);
    }
    if (message.initialInput !== undefined) {
      writer.uint32(90).string(message.initialInput);
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(98).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(106).fork()).join();
    }
    if (message.createdBy !== undefined) {
      writer.uint32(114).string(message.createdBy);
    }
    if (message.isDraftPart !== false) {
      writer.uint32(120).bool(message.isDraftPart);
    }
    if (message.numericId !== undefined) {
      writer.uint32(128).int32(message.numericId);
    }
    if (message.slug !== undefined) {
      writer.uint32(138).string(message.slug);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentEntity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.details = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.initialInput = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 98) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 13: {
          if (tag !== 106) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 14: {
          if (tag !== 114) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 15: {
          if (tag !== 120) {
            break;
          }

          message.isDraftPart = reader.bool();
          continue;
        }
        case 16: {
          if (tag !== 128) {
            break;
          }

          message.numericId = reader.int32();
          continue;
        }
        case 17: {
          if (tag !== 138) {
            break;
          }

          message.slug = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentEntity {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      type: isSet(object.type) ? documentTypeFromJSON(object.type) : 0,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : "",
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      details: isSet(object.details) ? globalThis.String(object.details) : undefined,
      templateId: isSet(object.templateId)
        ? globalThis.String(object.templateId)
        : isSet(object.template_id)
        ? globalThis.String(object.template_id)
        : "",
      initialInput: isSet(object.initialInput)
        ? globalThis.String(object.initialInput)
        : isSet(object.initial_input)
        ? globalThis.String(object.initial_input)
        : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : undefined,
      isDraftPart: isSet(object.isDraftPart)
        ? globalThis.Boolean(object.isDraftPart)
        : isSet(object.is_draft_part)
        ? globalThis.Boolean(object.is_draft_part)
        : false,
      numericId: isSet(object.numericId)
        ? globalThis.Number(object.numericId)
        : isSet(object.numeric_id)
        ? globalThis.Number(object.numeric_id)
        : undefined,
      slug: isSet(object.slug) ? globalThis.String(object.slug) : undefined,
    };
  },

  toJSON(message: DocumentEntity): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.type !== 0) {
      obj.type = documentTypeToJSON(message.type);
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.projectId !== "") {
      obj.projectId = message.projectId;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.details !== undefined) {
      obj.details = message.details;
    }
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.initialInput !== undefined) {
      obj.initialInput = message.initialInput;
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = message.createdBy;
    }
    if (message.isDraftPart !== false) {
      obj.isDraftPart = message.isDraftPart;
    }
    if (message.numericId !== undefined) {
      obj.numericId = Math.round(message.numericId);
    }
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentEntity>): DocumentEntity {
    return DocumentEntity.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentEntity>): DocumentEntity {
    const message = createBaseDocumentEntity();
    message.id = object.id ?? "";
    message.title = object.title ?? "";
    message.type = object.type ?? 0;
    message.companyId = object.companyId ?? 0;
    message.projectId = object.projectId ?? "";
    message.parentId = object.parentId ?? undefined;
    message.description = object.description ?? undefined;
    message.content = object.content ?? undefined;
    message.details = object.details ?? undefined;
    message.templateId = object.templateId ?? "";
    message.initialInput = object.initialInput ?? undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? undefined;
    message.isDraftPart = object.isDraftPart ?? false;
    message.numericId = object.numericId ?? undefined;
    message.slug = object.slug ?? undefined;
    return message;
  },
};

function createBaseDocumentInitialInput(): DocumentInitialInput {
  return { structuredInput: [], imageUrl: undefined, imageUrls: [], attachmentIds: [], issueAttachments: [] };
}

export const DocumentInitialInput: MessageFns<DocumentInitialInput> = {
  encode(message: DocumentInitialInput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.structuredInput) {
      DocumentSectionValue.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.imageUrl !== undefined) {
      writer.uint32(18).string(message.imageUrl);
    }
    for (const v of message.imageUrls) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.attachmentIds) {
      writer.uint32(34).string(v!);
    }
    for (const v of message.issueAttachments) {
      IssueAttachmentMetadata.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentInitialInput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentInitialInput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.structuredInput.push(DocumentSectionValue.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.imageUrl = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.imageUrls.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.attachmentIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.issueAttachments.push(IssueAttachmentMetadata.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentInitialInput {
    return {
      structuredInput: globalThis.Array.isArray(object?.structuredInput)
        ? object.structuredInput.map((e: any) => DocumentSectionValue.fromJSON(e))
        : globalThis.Array.isArray(object?.structured_input)
        ? object.structured_input.map((e: any) => DocumentSectionValue.fromJSON(e))
        : [],
      imageUrl: isSet(object.imageUrl)
        ? globalThis.String(object.imageUrl)
        : isSet(object.image_url)
        ? globalThis.String(object.image_url)
        : undefined,
      imageUrls: globalThis.Array.isArray(object?.imageUrls)
        ? object.imageUrls.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.image_urls)
        ? object.image_urls.map((e: any) => globalThis.String(e))
        : [],
      attachmentIds: globalThis.Array.isArray(object?.attachmentIds)
        ? object.attachmentIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.attachment_ids)
        ? object.attachment_ids.map((e: any) => globalThis.String(e))
        : [],
      issueAttachments: globalThis.Array.isArray(object?.issueAttachments)
        ? object.issueAttachments.map((e: any) => IssueAttachmentMetadata.fromJSON(e))
        : globalThis.Array.isArray(object?.issue_attachments)
        ? object.issue_attachments.map((e: any) => IssueAttachmentMetadata.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DocumentInitialInput): unknown {
    const obj: any = {};
    if (message.structuredInput?.length) {
      obj.structuredInput = message.structuredInput.map((e) => DocumentSectionValue.toJSON(e));
    }
    if (message.imageUrl !== undefined) {
      obj.imageUrl = message.imageUrl;
    }
    if (message.imageUrls?.length) {
      obj.imageUrls = message.imageUrls;
    }
    if (message.attachmentIds?.length) {
      obj.attachmentIds = message.attachmentIds;
    }
    if (message.issueAttachments?.length) {
      obj.issueAttachments = message.issueAttachments.map((e) => IssueAttachmentMetadata.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentInitialInput>): DocumentInitialInput {
    return DocumentInitialInput.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentInitialInput>): DocumentInitialInput {
    const message = createBaseDocumentInitialInput();
    message.structuredInput = object.structuredInput?.map((e) => DocumentSectionValue.fromPartial(e)) || [];
    message.imageUrl = object.imageUrl ?? undefined;
    message.imageUrls = object.imageUrls?.map((e) => e) || [];
    message.attachmentIds = object.attachmentIds?.map((e) => e) || [];
    message.issueAttachments = object.issueAttachments?.map((e) => IssueAttachmentMetadata.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDocumentSectionValue(): DocumentSectionValue {
  return { name: "", value: "" };
}

export const DocumentSectionValue: MessageFns<DocumentSectionValue> = {
  encode(message: DocumentSectionValue, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentSectionValue {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentSectionValue();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentSectionValue {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: DocumentSectionValue): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentSectionValue>): DocumentSectionValue {
    return DocumentSectionValue.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentSectionValue>): DocumentSectionValue {
    const message = createBaseDocumentSectionValue();
    message.name = object.name ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBaseProjectEntity(): ProjectEntity {
  return {
    id: "",
    templateId: "",
    companyId: 0,
    title: "",
    details: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    createdBy: undefined,
    numericId: undefined,
    slug: undefined,
    kind: undefined,
    isArchived: false,
  };
}

export const ProjectEntity: MessageFns<ProjectEntity> = {
  encode(message: ProjectEntity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.templateId !== "") {
      writer.uint32(18).string(message.templateId);
    }
    if (message.companyId !== 0) {
      writer.uint32(24).int32(message.companyId);
    }
    if (message.title !== "") {
      writer.uint32(34).string(message.title);
    }
    if (message.details !== undefined) {
      ProjectDetails.encode(message.details, writer.uint32(42).fork()).join();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).join();
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(toTimestamp(message.updatedAt), writer.uint32(58).fork()).join();
    }
    if (message.createdBy !== undefined) {
      writer.uint32(66).string(message.createdBy);
    }
    if (message.numericId !== undefined) {
      writer.uint32(72).int32(message.numericId);
    }
    if (message.slug !== undefined) {
      writer.uint32(82).string(message.slug);
    }
    if (message.kind !== undefined) {
      writer.uint32(90).string(message.kind);
    }
    if (message.isArchived !== false) {
      writer.uint32(96).bool(message.isArchived);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectEntity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectEntity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.templateId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.title = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.details = ProjectDetails.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.updatedAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.createdBy = reader.string();
          continue;
        }
        case 9: {
          if (tag !== 72) {
            break;
          }

          message.numericId = reader.int32();
          continue;
        }
        case 10: {
          if (tag !== 82) {
            break;
          }

          message.slug = reader.string();
          continue;
        }
        case 11: {
          if (tag !== 90) {
            break;
          }

          message.kind = reader.string();
          continue;
        }
        case 12: {
          if (tag !== 96) {
            break;
          }

          message.isArchived = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectEntity {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      templateId: isSet(object.templateId)
        ? globalThis.String(object.templateId)
        : isSet(object.template_id)
        ? globalThis.String(object.template_id)
        : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : "",
      details: isSet(object.details) ? ProjectDetails.fromJSON(object.details) : undefined,
      createdAt: isSet(object.createdAt)
        ? fromJsonTimestamp(object.createdAt)
        : isSet(object.created_at)
        ? fromJsonTimestamp(object.created_at)
        : undefined,
      updatedAt: isSet(object.updatedAt)
        ? fromJsonTimestamp(object.updatedAt)
        : isSet(object.updated_at)
        ? fromJsonTimestamp(object.updated_at)
        : undefined,
      createdBy: isSet(object.createdBy)
        ? globalThis.String(object.createdBy)
        : isSet(object.created_by)
        ? globalThis.String(object.created_by)
        : undefined,
      numericId: isSet(object.numericId)
        ? globalThis.Number(object.numericId)
        : isSet(object.numeric_id)
        ? globalThis.Number(object.numeric_id)
        : undefined,
      slug: isSet(object.slug) ? globalThis.String(object.slug) : undefined,
      kind: isSet(object.kind) ? globalThis.String(object.kind) : undefined,
      isArchived: isSet(object.isArchived)
        ? globalThis.Boolean(object.isArchived)
        : isSet(object.is_archived)
        ? globalThis.Boolean(object.is_archived)
        : false,
    };
  },

  toJSON(message: ProjectEntity): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.templateId !== "") {
      obj.templateId = message.templateId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.title !== "") {
      obj.title = message.title;
    }
    if (message.details !== undefined) {
      obj.details = ProjectDetails.toJSON(message.details);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = message.updatedAt.toISOString();
    }
    if (message.createdBy !== undefined) {
      obj.createdBy = message.createdBy;
    }
    if (message.numericId !== undefined) {
      obj.numericId = Math.round(message.numericId);
    }
    if (message.slug !== undefined) {
      obj.slug = message.slug;
    }
    if (message.kind !== undefined) {
      obj.kind = message.kind;
    }
    if (message.isArchived !== false) {
      obj.isArchived = message.isArchived;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectEntity>): ProjectEntity {
    return ProjectEntity.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectEntity>): ProjectEntity {
    const message = createBaseProjectEntity();
    message.id = object.id ?? "";
    message.templateId = object.templateId ?? "";
    message.companyId = object.companyId ?? 0;
    message.title = object.title ?? "";
    message.details = (object.details !== undefined && object.details !== null)
      ? ProjectDetails.fromPartial(object.details)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.updatedAt = object.updatedAt ?? undefined;
    message.createdBy = object.createdBy ?? undefined;
    message.numericId = object.numericId ?? undefined;
    message.slug = object.slug ?? undefined;
    message.kind = object.kind ?? undefined;
    message.isArchived = object.isArchived ?? false;
    return message;
  },
};

function createBaseStageTimeline(): StageTimeline {
  return { start: undefined, finish: undefined };
}

export const StageTimeline: MessageFns<StageTimeline> = {
  encode(message: StageTimeline, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== undefined) {
      Timestamp.encode(toTimestamp(message.start), writer.uint32(10).fork()).join();
    }
    if (message.finish !== undefined) {
      Timestamp.encode(toTimestamp(message.finish), writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): StageTimeline {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseStageTimeline();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.start = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.finish = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): StageTimeline {
    return {
      start: isSet(object.start) ? fromJsonTimestamp(object.start) : undefined,
      finish: isSet(object.finish) ? fromJsonTimestamp(object.finish) : undefined,
    };
  },

  toJSON(message: StageTimeline): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = message.start.toISOString();
    }
    if (message.finish !== undefined) {
      obj.finish = message.finish.toISOString();
    }
    return obj;
  },

  create(base?: DeepPartial<StageTimeline>): StageTimeline {
    return StageTimeline.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<StageTimeline>): StageTimeline {
    const message = createBaseStageTimeline();
    message.start = object.start ?? undefined;
    message.finish = object.finish ?? undefined;
    return message;
  },
};

function createBaseProjectDetails(): ProjectDetails {
  return {
    status: 0,
    owner: undefined,
    description: undefined,
    tagIds: [],
    definition: undefined,
    development: undefined,
    delivery: undefined,
    releaseId: undefined,
  };
}

export const ProjectDetails: MessageFns<ProjectDetails> = {
  encode(message: ProjectDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    if (message.owner !== undefined) {
      writer.uint32(18).string(message.owner);
    }
    if (message.description !== undefined) {
      writer.uint32(26).string(message.description);
    }
    for (const v of message.tagIds) {
      writer.uint32(34).string(v!);
    }
    if (message.definition !== undefined) {
      StageTimeline.encode(message.definition, writer.uint32(42).fork()).join();
    }
    if (message.development !== undefined) {
      StageTimeline.encode(message.development, writer.uint32(50).fork()).join();
    }
    if (message.delivery !== undefined) {
      StageTimeline.encode(message.delivery, writer.uint32(58).fork()).join();
    }
    if (message.releaseId !== undefined) {
      writer.uint32(66).string(message.releaseId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.owner = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.description = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tagIds.push(reader.string());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.definition = StageTimeline.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.development = StageTimeline.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.delivery = StageTimeline.decode(reader, reader.uint32());
          continue;
        }
        case 8: {
          if (tag !== 66) {
            break;
          }

          message.releaseId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectDetails {
    return {
      status: isSet(object.status) ? projectStatusFromJSON(object.status) : 0,
      owner: isSet(object.owner) ? globalThis.String(object.owner) : undefined,
      description: isSet(object.description) ? globalThis.String(object.description) : undefined,
      tagIds: globalThis.Array.isArray(object?.tagIds)
        ? object.tagIds.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.tag_ids)
        ? object.tag_ids.map((e: any) => globalThis.String(e))
        : [],
      definition: isSet(object.definition) ? StageTimeline.fromJSON(object.definition) : undefined,
      development: isSet(object.development) ? StageTimeline.fromJSON(object.development) : undefined,
      delivery: isSet(object.delivery) ? StageTimeline.fromJSON(object.delivery) : undefined,
      releaseId: isSet(object.releaseId)
        ? globalThis.String(object.releaseId)
        : isSet(object.release_id)
        ? globalThis.String(object.release_id)
        : undefined,
    };
  },

  toJSON(message: ProjectDetails): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = projectStatusToJSON(message.status);
    }
    if (message.owner !== undefined) {
      obj.owner = message.owner;
    }
    if (message.description !== undefined) {
      obj.description = message.description;
    }
    if (message.tagIds?.length) {
      obj.tagIds = message.tagIds;
    }
    if (message.definition !== undefined) {
      obj.definition = StageTimeline.toJSON(message.definition);
    }
    if (message.development !== undefined) {
      obj.development = StageTimeline.toJSON(message.development);
    }
    if (message.delivery !== undefined) {
      obj.delivery = StageTimeline.toJSON(message.delivery);
    }
    if (message.releaseId !== undefined) {
      obj.releaseId = message.releaseId;
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectDetails>): ProjectDetails {
    return ProjectDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectDetails>): ProjectDetails {
    const message = createBaseProjectDetails();
    message.status = object.status ?? 0;
    message.owner = object.owner ?? undefined;
    message.description = object.description ?? undefined;
    message.tagIds = object.tagIds?.map((e) => e) || [];
    message.definition = (object.definition !== undefined && object.definition !== null)
      ? StageTimeline.fromPartial(object.definition)
      : undefined;
    message.development = (object.development !== undefined && object.development !== null)
      ? StageTimeline.fromPartial(object.development)
      : undefined;
    message.delivery = (object.delivery !== undefined && object.delivery !== null)
      ? StageTimeline.fromPartial(object.delivery)
      : undefined;
    message.releaseId = object.releaseId ?? undefined;
    return message;
  },
};

function createBaseCustomDocumentDetails(): CustomDocumentDetails {
  return { extraPromptParams: {} };
}

export const CustomDocumentDetails: MessageFns<CustomDocumentDetails> = {
  encode(message: CustomDocumentDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.extraPromptParams).forEach(([key, value]: [string, string]) => {
      CustomDocumentDetails_ExtraPromptParamsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomDocumentDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomDocumentDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = CustomDocumentDetails_ExtraPromptParamsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.extraPromptParams[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomDocumentDetails {
    return {
      extraPromptParams: isObject(object.extraPromptParams)
        ? (globalThis.Object.entries(object.extraPromptParams) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : isObject(object.extra_prompt_params)
        ? (globalThis.Object.entries(object.extra_prompt_params) as [string, any][]).reduce(
          (acc: { [key: string]: string }, [key, value]: [string, any]) => {
            acc[key] = globalThis.String(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: CustomDocumentDetails): unknown {
    const obj: any = {};
    if (message.extraPromptParams) {
      const entries = globalThis.Object.entries(message.extraPromptParams) as [string, string][];
      if (entries.length > 0) {
        obj.extraPromptParams = {};
        entries.forEach(([k, v]) => {
          obj.extraPromptParams[k] = v;
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<CustomDocumentDetails>): CustomDocumentDetails {
    return CustomDocumentDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CustomDocumentDetails>): CustomDocumentDetails {
    const message = createBaseCustomDocumentDetails();
    message.extraPromptParams = (globalThis.Object.entries(object.extraPromptParams ?? {}) as [string, string][])
      .reduce((acc: { [key: string]: string }, [key, value]: [string, string]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseCustomDocumentDetails_ExtraPromptParamsEntry(): CustomDocumentDetails_ExtraPromptParamsEntry {
  return { key: "", value: "" };
}

export const CustomDocumentDetails_ExtraPromptParamsEntry: MessageFns<CustomDocumentDetails_ExtraPromptParamsEntry> = {
  encode(
    message: CustomDocumentDetails_ExtraPromptParamsEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== "") {
      writer.uint32(18).string(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CustomDocumentDetails_ExtraPromptParamsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCustomDocumentDetails_ExtraPromptParamsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CustomDocumentDetails_ExtraPromptParamsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.String(object.value) : "",
    };
  },

  toJSON(message: CustomDocumentDetails_ExtraPromptParamsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== "") {
      obj.value = message.value;
    }
    return obj;
  },

  create(
    base?: DeepPartial<CustomDocumentDetails_ExtraPromptParamsEntry>,
  ): CustomDocumentDetails_ExtraPromptParamsEntry {
    return CustomDocumentDetails_ExtraPromptParamsEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<CustomDocumentDetails_ExtraPromptParamsEntry>,
  ): CustomDocumentDetails_ExtraPromptParamsEntry {
    const message = createBaseCustomDocumentDetails_ExtraPromptParamsEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? "";
    return message;
  },
};

function createBasePrdDetails(): PrdDetails {
  return { userProvidedSpec: false, summary: undefined };
}

export const PrdDetails: MessageFns<PrdDetails> = {
  encode(message: PrdDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.userProvidedSpec !== false) {
      writer.uint32(8).bool(message.userProvidedSpec);
    }
    if (message.summary !== undefined) {
      writer.uint32(18).string(message.summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PrdDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePrdDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.userProvidedSpec = reader.bool();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PrdDetails {
    return {
      userProvidedSpec: isSet(object.userProvidedSpec)
        ? globalThis.Boolean(object.userProvidedSpec)
        : isSet(object.user_provided_spec)
        ? globalThis.Boolean(object.user_provided_spec)
        : false,
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
    };
  },

  toJSON(message: PrdDetails): unknown {
    const obj: any = {};
    if (message.userProvidedSpec !== false) {
      obj.userProvidedSpec = message.userProvidedSpec;
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    return obj;
  },

  create(base?: DeepPartial<PrdDetails>): PrdDetails {
    return PrdDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<PrdDetails>): PrdDetails {
    const message = createBasePrdDetails();
    message.userProvidedSpec = object.userProvidedSpec ?? false;
    message.summary = object.summary ?? undefined;
    return message;
  },
};

function createBaseIdeaDiscoveryDetails(): IdeaDiscoveryDetails {
  return { riceScore: undefined, summary: undefined };
}

export const IdeaDiscoveryDetails: MessageFns<IdeaDiscoveryDetails> = {
  encode(message: IdeaDiscoveryDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.riceScore !== undefined) {
      RiceScore.encode(message.riceScore, writer.uint32(10).fork()).join();
    }
    if (message.summary !== undefined) {
      writer.uint32(18).string(message.summary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): IdeaDiscoveryDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseIdeaDiscoveryDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.riceScore = RiceScore.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.summary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): IdeaDiscoveryDetails {
    return {
      riceScore: isSet(object.riceScore)
        ? RiceScore.fromJSON(object.riceScore)
        : isSet(object.rice_score)
        ? RiceScore.fromJSON(object.rice_score)
        : undefined,
      summary: isSet(object.summary) ? globalThis.String(object.summary) : undefined,
    };
  },

  toJSON(message: IdeaDiscoveryDetails): unknown {
    const obj: any = {};
    if (message.riceScore !== undefined) {
      obj.riceScore = RiceScore.toJSON(message.riceScore);
    }
    if (message.summary !== undefined) {
      obj.summary = message.summary;
    }
    return obj;
  },

  create(base?: DeepPartial<IdeaDiscoveryDetails>): IdeaDiscoveryDetails {
    return IdeaDiscoveryDetails.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<IdeaDiscoveryDetails>): IdeaDiscoveryDetails {
    const message = createBaseIdeaDiscoveryDetails();
    message.riceScore = (object.riceScore !== undefined && object.riceScore !== null)
      ? RiceScore.fromPartial(object.riceScore)
      : undefined;
    message.summary = object.summary ?? undefined;
    return message;
  },
};

function createBaseReachScore(): ReachScore {
  return { score: 0, reasoning: undefined };
}

export const ReachScore: MessageFns<ReachScore> = {
  encode(message: ReachScore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.score !== 0) {
      writer.uint32(9).double(message.score);
    }
    if (message.reasoning !== undefined) {
      writer.uint32(18).string(message.reasoning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReachScore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReachScore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.score = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reasoning = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReachScore {
    return {
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      reasoning: isSet(object.reasoning) ? globalThis.String(object.reasoning) : undefined,
    };
  },

  toJSON(message: ReachScore): unknown {
    const obj: any = {};
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.reasoning !== undefined) {
      obj.reasoning = message.reasoning;
    }
    return obj;
  },

  create(base?: DeepPartial<ReachScore>): ReachScore {
    return ReachScore.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ReachScore>): ReachScore {
    const message = createBaseReachScore();
    message.score = object.score ?? 0;
    message.reasoning = object.reasoning ?? undefined;
    return message;
  },
};

function createBaseImpactScore(): ImpactScore {
  return { score: 0, reasoning: undefined, label: undefined };
}

export const ImpactScore: MessageFns<ImpactScore> = {
  encode(message: ImpactScore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.score !== 0) {
      writer.uint32(9).double(message.score);
    }
    if (message.reasoning !== undefined) {
      writer.uint32(18).string(message.reasoning);
    }
    if (message.label !== undefined) {
      writer.uint32(26).string(message.label);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ImpactScore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseImpactScore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.score = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reasoning = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.label = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ImpactScore {
    return {
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      reasoning: isSet(object.reasoning) ? globalThis.String(object.reasoning) : undefined,
      label: isSet(object.label) ? globalThis.String(object.label) : undefined,
    };
  },

  toJSON(message: ImpactScore): unknown {
    const obj: any = {};
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.reasoning !== undefined) {
      obj.reasoning = message.reasoning;
    }
    if (message.label !== undefined) {
      obj.label = message.label;
    }
    return obj;
  },

  create(base?: DeepPartial<ImpactScore>): ImpactScore {
    return ImpactScore.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ImpactScore>): ImpactScore {
    const message = createBaseImpactScore();
    message.score = object.score ?? 0;
    message.reasoning = object.reasoning ?? undefined;
    message.label = object.label ?? undefined;
    return message;
  },
};

function createBaseConfidenceScore(): ConfidenceScore {
  return { score: 0, reasoning: undefined };
}

export const ConfidenceScore: MessageFns<ConfidenceScore> = {
  encode(message: ConfidenceScore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.score !== 0) {
      writer.uint32(9).double(message.score);
    }
    if (message.reasoning !== undefined) {
      writer.uint32(18).string(message.reasoning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfidenceScore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfidenceScore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.score = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reasoning = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfidenceScore {
    return {
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      reasoning: isSet(object.reasoning) ? globalThis.String(object.reasoning) : undefined,
    };
  },

  toJSON(message: ConfidenceScore): unknown {
    const obj: any = {};
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.reasoning !== undefined) {
      obj.reasoning = message.reasoning;
    }
    return obj;
  },

  create(base?: DeepPartial<ConfidenceScore>): ConfidenceScore {
    return ConfidenceScore.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ConfidenceScore>): ConfidenceScore {
    const message = createBaseConfidenceScore();
    message.score = object.score ?? 0;
    message.reasoning = object.reasoning ?? undefined;
    return message;
  },
};

function createBaseEffortScore(): EffortScore {
  return { score: 0, reasoning: undefined };
}

export const EffortScore: MessageFns<EffortScore> = {
  encode(message: EffortScore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.score !== 0) {
      writer.uint32(9).double(message.score);
    }
    if (message.reasoning !== undefined) {
      writer.uint32(18).string(message.reasoning);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): EffortScore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEffortScore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 9) {
            break;
          }

          message.score = reader.double();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.reasoning = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EffortScore {
    return {
      score: isSet(object.score) ? globalThis.Number(object.score) : 0,
      reasoning: isSet(object.reasoning) ? globalThis.String(object.reasoning) : undefined,
    };
  },

  toJSON(message: EffortScore): unknown {
    const obj: any = {};
    if (message.score !== 0) {
      obj.score = message.score;
    }
    if (message.reasoning !== undefined) {
      obj.reasoning = message.reasoning;
    }
    return obj;
  },

  create(base?: DeepPartial<EffortScore>): EffortScore {
    return EffortScore.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EffortScore>): EffortScore {
    const message = createBaseEffortScore();
    message.score = object.score ?? 0;
    message.reasoning = object.reasoning ?? undefined;
    return message;
  },
};

function createBaseRiceScore(): RiceScore {
  return { reach: undefined, impact: undefined, confidence: undefined, effort: undefined, executiveSummary: undefined };
}

export const RiceScore: MessageFns<RiceScore> = {
  encode(message: RiceScore, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.reach !== undefined) {
      ReachScore.encode(message.reach, writer.uint32(10).fork()).join();
    }
    if (message.impact !== undefined) {
      ImpactScore.encode(message.impact, writer.uint32(18).fork()).join();
    }
    if (message.confidence !== undefined) {
      ConfidenceScore.encode(message.confidence, writer.uint32(26).fork()).join();
    }
    if (message.effort !== undefined) {
      EffortScore.encode(message.effort, writer.uint32(34).fork()).join();
    }
    if (message.executiveSummary !== undefined) {
      writer.uint32(42).string(message.executiveSummary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RiceScore {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRiceScore();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.reach = ReachScore.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.impact = ImpactScore.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.confidence = ConfidenceScore.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.effort = EffortScore.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.executiveSummary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RiceScore {
    return {
      reach: isSet(object.reach) ? ReachScore.fromJSON(object.reach) : undefined,
      impact: isSet(object.impact) ? ImpactScore.fromJSON(object.impact) : undefined,
      confidence: isSet(object.confidence) ? ConfidenceScore.fromJSON(object.confidence) : undefined,
      effort: isSet(object.effort) ? EffortScore.fromJSON(object.effort) : undefined,
      executiveSummary: isSet(object.executiveSummary)
        ? globalThis.String(object.executiveSummary)
        : isSet(object.executive_summary)
        ? globalThis.String(object.executive_summary)
        : undefined,
    };
  },

  toJSON(message: RiceScore): unknown {
    const obj: any = {};
    if (message.reach !== undefined) {
      obj.reach = ReachScore.toJSON(message.reach);
    }
    if (message.impact !== undefined) {
      obj.impact = ImpactScore.toJSON(message.impact);
    }
    if (message.confidence !== undefined) {
      obj.confidence = ConfidenceScore.toJSON(message.confidence);
    }
    if (message.effort !== undefined) {
      obj.effort = EffortScore.toJSON(message.effort);
    }
    if (message.executiveSummary !== undefined) {
      obj.executiveSummary = message.executiveSummary;
    }
    return obj;
  },

  create(base?: DeepPartial<RiceScore>): RiceScore {
    return RiceScore.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RiceScore>): RiceScore {
    const message = createBaseRiceScore();
    message.reach = (object.reach !== undefined && object.reach !== null)
      ? ReachScore.fromPartial(object.reach)
      : undefined;
    message.impact = (object.impact !== undefined && object.impact !== null)
      ? ImpactScore.fromPartial(object.impact)
      : undefined;
    message.confidence = (object.confidence !== undefined && object.confidence !== null)
      ? ConfidenceScore.fromPartial(object.confidence)
      : undefined;
    message.effort = (object.effort !== undefined && object.effort !== null)
      ? EffortScore.fromPartial(object.effort)
      : undefined;
    message.executiveSummary = object.executiveSummary ?? undefined;
    return message;
  },
};

function createBaseProjectWithDocs(): ProjectWithDocs {
  return { project: undefined, docs: [] };
}

export const ProjectWithDocs: MessageFns<ProjectWithDocs> = {
  encode(message: ProjectWithDocs, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(10).fork()).join();
    }
    for (const v of message.docs) {
      DocumentEntity.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ProjectWithDocs {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseProjectWithDocs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.docs.push(DocumentEntity.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ProjectWithDocs {
    return {
      project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined,
      docs: globalThis.Array.isArray(object?.docs) ? object.docs.map((e: any) => DocumentEntity.fromJSON(e)) : [],
    };
  },

  toJSON(message: ProjectWithDocs): unknown {
    const obj: any = {};
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    if (message.docs?.length) {
      obj.docs = message.docs.map((e) => DocumentEntity.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ProjectWithDocs>): ProjectWithDocs {
    return ProjectWithDocs.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ProjectWithDocs>): ProjectWithDocs {
    const message = createBaseProjectWithDocs();
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    message.docs = object.docs?.map((e) => DocumentEntity.fromPartial(e)) || [];
    return message;
  },
};

function createBaseDocumentWithProject(): DocumentWithProject {
  return { doc: undefined, project: undefined };
}

export const DocumentWithProject: MessageFns<DocumentWithProject> = {
  encode(message: DocumentWithProject, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.doc !== undefined) {
      DocumentEntity.encode(message.doc, writer.uint32(10).fork()).join();
    }
    if (message.project !== undefined) {
      ProjectEntity.encode(message.project, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DocumentWithProject {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDocumentWithProject();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.doc = DocumentEntity.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.project = ProjectEntity.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DocumentWithProject {
    return {
      doc: isSet(object.doc) ? DocumentEntity.fromJSON(object.doc) : undefined,
      project: isSet(object.project) ? ProjectEntity.fromJSON(object.project) : undefined,
    };
  },

  toJSON(message: DocumentWithProject): unknown {
    const obj: any = {};
    if (message.doc !== undefined) {
      obj.doc = DocumentEntity.toJSON(message.doc);
    }
    if (message.project !== undefined) {
      obj.project = ProjectEntity.toJSON(message.project);
    }
    return obj;
  },

  create(base?: DeepPartial<DocumentWithProject>): DocumentWithProject {
    return DocumentWithProject.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<DocumentWithProject>): DocumentWithProject {
    const message = createBaseDocumentWithProject();
    message.doc = (object.doc !== undefined && object.doc !== null)
      ? DocumentEntity.fromPartial(object.doc)
      : undefined;
    message.project = (object.project !== undefined && object.project !== null)
      ? ProjectEntity.fromPartial(object.project)
      : undefined;
    return message;
  },
};

function createBaseSteppedFeaturePromptContent(): SteppedFeaturePromptContent {
  return { steps: [], requirementsSummary: "" };
}

export const SteppedFeaturePromptContent: MessageFns<SteppedFeaturePromptContent> = {
  encode(message: SteppedFeaturePromptContent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.steps) {
      SteppedFeaturePromptContent_Step.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.requirementsSummary !== "") {
      writer.uint32(18).string(message.requirementsSummary);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SteppedFeaturePromptContent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSteppedFeaturePromptContent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.steps.push(SteppedFeaturePromptContent_Step.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.requirementsSummary = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SteppedFeaturePromptContent {
    return {
      steps: globalThis.Array.isArray(object?.steps)
        ? object.steps.map((e: any) => SteppedFeaturePromptContent_Step.fromJSON(e))
        : [],
      requirementsSummary: isSet(object.requirementsSummary)
        ? globalThis.String(object.requirementsSummary)
        : isSet(object.requirements_summary)
        ? globalThis.String(object.requirements_summary)
        : "",
    };
  },

  toJSON(message: SteppedFeaturePromptContent): unknown {
    const obj: any = {};
    if (message.steps?.length) {
      obj.steps = message.steps.map((e) => SteppedFeaturePromptContent_Step.toJSON(e));
    }
    if (message.requirementsSummary !== "") {
      obj.requirementsSummary = message.requirementsSummary;
    }
    return obj;
  },

  create(base?: DeepPartial<SteppedFeaturePromptContent>): SteppedFeaturePromptContent {
    return SteppedFeaturePromptContent.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SteppedFeaturePromptContent>): SteppedFeaturePromptContent {
    const message = createBaseSteppedFeaturePromptContent();
    message.steps = object.steps?.map((e) => SteppedFeaturePromptContent_Step.fromPartial(e)) || [];
    message.requirementsSummary = object.requirementsSummary ?? "";
    return message;
  },
};

function createBaseSteppedFeaturePromptContent_Step(): SteppedFeaturePromptContent_Step {
  return { name: "", instructions: "" };
}

export const SteppedFeaturePromptContent_Step: MessageFns<SteppedFeaturePromptContent_Step> = {
  encode(message: SteppedFeaturePromptContent_Step, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.name !== "") {
      writer.uint32(10).string(message.name);
    }
    if (message.instructions !== "") {
      writer.uint32(18).string(message.instructions);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SteppedFeaturePromptContent_Step {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSteppedFeaturePromptContent_Step();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.instructions = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SteppedFeaturePromptContent_Step {
    return {
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : "",
    };
  },

  toJSON(message: SteppedFeaturePromptContent_Step): unknown {
    const obj: any = {};
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.instructions !== "") {
      obj.instructions = message.instructions;
    }
    return obj;
  },

  create(base?: DeepPartial<SteppedFeaturePromptContent_Step>): SteppedFeaturePromptContent_Step {
    return SteppedFeaturePromptContent_Step.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SteppedFeaturePromptContent_Step>): SteppedFeaturePromptContent_Step {
    const message = createBaseSteppedFeaturePromptContent_Step();
    message.name = object.name ?? "";
    message.instructions = object.instructions ?? "";
    return message;
  },
};

function createBaseRelease(): Release {
  return { id: "", meta: undefined, name: "", companyId: 0, archived: false, targetDate: undefined, projectOrder: [] };
}

export const Release: MessageFns<Release> = {
  encode(message: Release, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.name !== "") {
      writer.uint32(26).string(message.name);
    }
    if (message.companyId !== 0) {
      writer.uint32(32).int32(message.companyId);
    }
    if (message.archived !== false) {
      writer.uint32(40).bool(message.archived);
    }
    if (message.targetDate !== undefined) {
      Timestamp.encode(toTimestamp(message.targetDate), writer.uint32(50).fork()).join();
    }
    for (const v of message.projectOrder) {
      writer.uint32(58).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Release {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRelease();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.name = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 5: {
          if (tag !== 40) {
            break;
          }

          message.archived = reader.bool();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.targetDate = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.projectOrder.push(reader.string());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Release {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      archived: isSet(object.archived) ? globalThis.Boolean(object.archived) : false,
      targetDate: isSet(object.targetDate)
        ? fromJsonTimestamp(object.targetDate)
        : isSet(object.target_date)
        ? fromJsonTimestamp(object.target_date)
        : undefined,
      projectOrder: globalThis.Array.isArray(object?.projectOrder)
        ? object.projectOrder.map((e: any) => globalThis.String(e))
        : globalThis.Array.isArray(object?.project_order)
        ? object.project_order.map((e: any) => globalThis.String(e))
        : [],
    };
  },

  toJSON(message: Release): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.archived !== false) {
      obj.archived = message.archived;
    }
    if (message.targetDate !== undefined) {
      obj.targetDate = message.targetDate.toISOString();
    }
    if (message.projectOrder?.length) {
      obj.projectOrder = message.projectOrder;
    }
    return obj;
  },

  create(base?: DeepPartial<Release>): Release {
    return Release.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Release>): Release {
    const message = createBaseRelease();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.name = object.name ?? "";
    message.companyId = object.companyId ?? 0;
    message.archived = object.archived ?? false;
    message.targetDate = object.targetDate ?? undefined;
    message.projectOrder = object.projectOrder?.map((e) => e) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
